import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioAgeGroupServiceEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioAgeGroupServiceEntity
